import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as Actions from "../../../../../../../store/modules/journals";
import * as FActions from "../../../../../../../store/modules/footer";

import DropdownTreeSelect from "react-dropdown-tree-select";
import * as func from "../../../../../../../utils/functions";

class JournalCategory2 extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isInit: false,
			searchKeyword: '',
			category: [],
			categoryValue: [],
			categoryNewValue: [],
			categoryOriginal: [],
			categorySelect: {},
			categoryName: {},
			record_id: this.props.record_id,
		}

		func.getData("category/" + this.props.type, {}).then((response) => {
			const t = {};
			t.category = [];
			t.categoryName = {}
			t.isInit = true;
			let tt = {};
			response.records.map((r, i) => {
				t.categoryName[r.category_id] = r.category_name
				if (r.up_category_id === 0) {
					const temp = {
						label: r.category_name,
						value: r.category_id,
						children: []
					};
					tt[temp.value] = temp;
				} else {
					const temp = {
						label: r.category_name,
						value: r.category_id,
						parent: r.up_category_id,
					}
					if (tt[r.up_category_id])
						tt[r.up_category_id].children.push(temp)
				}
			});
			Object.keys(tt).map((key) => {
				t.category.push(tt[key])
			});

			t.categoryOriginal = t.category;

			let categorySelect = {};
			let categoryValue = [];
			// console.log(this.props.category)
			this.props.category.map((item, index) => {
				if (item.up_category_id) {
					if (!categorySelect[item.up_category_id])
						categorySelect[item.up_category_id] = {}

					categorySelect[item.up_category_id].label = t.categoryName[item.up_category_id];
					categorySelect[item.up_category_id].value = item.up_category_id;

					if (!categorySelect[item.up_category_id].children)
						categorySelect[item.up_category_id].children = {}

					categorySelect[item.up_category_id].children[item.category_id] = {
						label: item.category_name,
						value: item.category_id
					};
					categoryValue.push(item.category_id)
				} else {
					if (!categorySelect[item.category_id]) {
						categorySelect[item.category_id] = {}

						categorySelect[item.category_id].label = item.category_name;
						categorySelect[item.category_id].value = item.category_id;
						categorySelect[item.category_id].children = {};

						categoryValue.push(item.category_id)
					}

				}
			});

			t.categoryValue = categoryValue;
			t.categorySelect = categorySelect;
			this.setState(t);
		});

		this.onInsert = this.onInsert.bind(this);
	}

	keyUp = () => {
		this.setState({searchKeyword: event.target.value})
	}

	onInsert(item) {
		let categorySelect = this.state.categorySelect;
		let categoryValue = this.state.categoryValue;
		let categoryNewValue = this.state.categoryNewValue;

		if (item.parent) {
			if (!categoryValue.includes(item.parent)) {
				func.getData("admin/category/insert", {
					record_id: this.state.record_id,
					category_id: item.parent
				}).then((response) => {
					if(response.code === 'ok') {
						if (!categorySelect[item.parent])
							categorySelect[item.parent] = {}
						categorySelect[item.parent].label = this.state.categoryName[item.parent];
						categorySelect[item.parent].value = item.parent;
						if (!categorySelect[item.parent].children)
							categorySelect[item.parent].children = {}
						categoryValue.push(item.parent)
						categoryNewValue.push(item.parent)

						this.setState({categorySelect: categorySelect, categoryValue: categoryValue})
						this.forceUpdate();
						this.add(categorySelect, item)
					}
				});
			} else {
				this.add(categorySelect, item)
			}
		} else {
			this.add(categorySelect, item)
		}
	}

	add(categorySelect, item) {
		if (!this.state.categoryValue.includes(item.value)) {
			func.getData("admin/category/insert", {
				record_id: this.state.record_id,
				category_id: item.value
			}).then((response) => {
				if(response.code === 'ok') {
					if (item.parent) {
						if (!categorySelect[item.parent].children)
							categorySelect[item.parent].children = {}
						if (!categorySelect[item.parent].children[item.value])
							categorySelect[item.parent].children[item.value] = {}
						categorySelect[item.parent].children[item.value].label = item.label;
						categorySelect[item.parent].children[item.value].value = item.value;
						categorySelect[item.parent].children[item.value].parent = item.parent;
					} else {
						if (!categorySelect[item.value])
							categorySelect[item.value] = {}
						categorySelect[item.value].label = item.label;
						categorySelect[item.value].value = item.value;
						categorySelect[item.value].children = {};
					}
					let categoryValue = this.state.categoryValue;
					categoryValue.push(item.value)
					let categoryNewValue = this.state.categoryNewValue;
					categoryNewValue.push(item.value)
					this.setState({categorySelect: categorySelect, categoryValue: categoryValue})
					this.forceUpdate();
				}
			});
		}
	}

	onDelete(item) {
		if (this.state.categoryValue.includes(item.value)) {
			func.getData("admin/category/delete", {
				record_id: this.state.record_id,
				category_id: item.value
			}).then((response) => {
				if(response.code === 'ok') {
					let categorySelect = this.state.categorySelect;
					let categoryValue = this.state.categoryValue;

					if (item.parent) {
						delete categorySelect[item.parent].children[item.value]
					} else {
						delete categorySelect[item.value]
					}
					categoryValue.splice(categoryValue.indexOf(item.value), 1);
					this.setState({categorySelect: categorySelect, categoryValue: categoryValue})
					this.forceUpdate();
				}
			});
		}
	}

	clone(obj){
		let output = {};
		for(let i in obj){
			output[i] = obj[i];
		}
		return output;
	}

	render() {
		if (!this.state.isInit)
			return '';

		let categorySelect = this.state.categorySelect
		let tmp = [];
		let category = this.state.category
		if(this.state.searchKeyword) {
			let c = this.state.category;
			Object.keys(c).map((index) => {
				const item = c[index];
				if(c[index].label.indexOf(this.state.searchKeyword) > -1) {
					let t = this.clone(c[index])
					t.children = []
					tmp.push(t);
				}
				if(item.children) {
					Object.keys(item.children).map((citem, cindex) => {
						let v = item.children[citem];
						if(v.label.indexOf(this.state.searchKeyword) > -1) {
							tmp.push(v);
						}
					})
				}
			})
			category = tmp;
		}

		return (
			<>
				<div className="card-header">
					<span className="font-weight-bold">{this.props.title}</span>
					<div className="float-end">
						<input type="text" className="" placeholder="카테고리 검색" value={this.state.searchKeyword} onChange={this.keyUp}/>
						<button type="button" className="btn-control"><span className="icon-search-gray"></span></button>
					</div>
				</div>
				<div>
					<div className="p-2 bg-light">
						{Object.keys(categorySelect).map((index) => {
							const item = categorySelect[index];
							if (Object.keys(item.children).length <= 0) {
								return (<div className={"btn-sm btn-success m-1 btn-delete text-left" +
								(this.state.categoryNewValue.includes(item.value) ? ' btn-danger' : '')}
									key={index}>
									<span onClick={() => this.onDelete(item)} />{item.label}</div>)
							} else {
								return (
									Object.keys(item.children).map((citem, cindex) => {
										let v = item.children[citem];
										v.parent = item.value
										return (<div className={"btn-sm btn-success m-1 btn-delete text-left" +
										(this.state.categoryNewValue.includes(item.children[citem].value) ? ' btn-danger' : '')}
											key={cindex}>
											<span  onClick={() => this.onDelete(v)}/>{item.label + ' > ' + item.children[citem].label}</div>)
									})
								)
							}
						})}
					</div>
				</div>
				<div className="card-body adminCatSelectBox"
				     style={{
					     minHeight: "42px",
					     maxHeight: "300px",
					     overflow: "auto",
					     padding: "1em",
					     border: "solid 1px #dcdcde",
					     backgroundColor: "#fff"
				     }}>
					<ul className="list-group list-group-flush border">
						{category.length > 0 && category.map((item, index) => {
							return (
								<Fragment key={index}>
									<li className="list-group-item m-0 p-1">
										<label className="mt-2 mb-0">{item.label}</label>
										<span className="btn float-right btn-sm btn-warning" onClick={() => this.onInsert(item)}>추가</span>
									</li>
									{item.children && item.children.map((citem, cindex) => {
										return (<li key={cindex} className="list-group-item m-0 p-1">
											<label className="ml-3 mt-2 mb-0">{citem.label}</label>

											<span className="btn float-right btn-sm btn-warning" onClick={() => this.onInsert(citem)} >추가</span>
										</li>)
									})}
								</Fragment>
							)
						})}
					</ul>
				</div>
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.journals.record ? state.journals.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(JournalCategory2)
